import { useMutation } from '@tanstack/react-query';
import { POST, PUT } from '../services/index';

/**
 * ทุกอย่างที่เกี่ยวกับ "รหัสผ่าน + 2FA" อยู่ไฟล์นี้ไฟล์เดียว
 *
 * มีสองฝั่งที่หน้าตาเหมือนกันแต่คนละ API:
 *   /api/v1/users           → พนักงาน (role 3) จัดการโดย admin ที่ /admin/employees
 *   /api/v1/usersbackoffice → บัญชี admin จัดการโดย backoffice ที่ /backoffice/employees
 * เลยรับ apiBase เข้ามาแทนที่จะเขียนซ้ำสองชุด
 *
 * ทุกตัวใช้ mutateAsync + ปล่อยให้ reject จริงเมื่อพัง — ห้าม catch แล้วกลืน error
 * ไม่งั้นหน้าจอจะขึ้นว่าสำเร็จทั้งที่ยังไม่ได้เปลี่ยนอะไร
 */

// --- ฝั่ง admin: จัดการบัญชีคนอื่น ---

export const useResetUserPassword = (apiBase) =>
  useMutation(async ({ id, password }) => await PUT(`${apiBase}/${id}/reset-password`, { password }));

export const useResetUserTotp = (apiBase) =>
  useMutation(async ({ id }) => await PUT(`${apiBase}/${id}/reset-totp`, {}));

export const useSetUserTotpRequired = (apiBase) =>
  useMutation(async ({ id, required }) => await PUT(`${apiBase}/${id}/totp-required`, { required }));

// --- ฝั่งผู้ใช้: จัดการบัญชีตัวเอง ---

// เปลี่ยนรหัสผ่านตอน login อยู่ — ยืนยันด้วยรหัส 6 หลัก ไม่ต้องกรอกรหัสเดิม
export const useChangeMyPassword = () =>
  useMutation(async ({ newPassword, totpToken }) =>
    await POST('/api/v1/authen/change-password', { newPassword, totpToken }));

// ลืมรหัสผ่าน — เรียกจากหน้า login ตอนยังไม่มี token
export const useForgotPassword = () =>
  useMutation(async ({ username, totpToken, newPassword }) =>
    await POST('/api/v1/authen/forgot-password', { username, totpToken, newPassword }));

/** สุ่มรหัสผ่านให้ admin ส่งต่อให้พนักงาน — เลี่ยงตัวที่อ่านสับสน (0/O, 1/l/I) */
export const generatePassword = (length = 10) => {
  const chars = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = new Uint32Array(length);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => chars[b % chars.length]).join('');
};

export const MIN_PASSWORD_LENGTH = 6;
